import React, { useEffect, useState, useRef } from "react";
import { FiSearch, FiUpload } from "react-icons/fi";
import { RiUserSearchLine } from "react-icons/ri";
import TransactionMonitoring from "./TransactionMonitoring";
import AmlTable from "./AmlTable";
import IpTable from "./IpTable";
import Navbar from "../../../components/Navbar";
import Sidebar from "../../../components/Sidebar";
import { API_URL, PROD_LINK, STAGING_LINK } from "../../../constant";
import { IS_STAGING } from "../../../constant/api";
import axiosInstance from "../../../utils/axiosConfig";
import { useNavigate } from "react-router-dom";

function exportToCsv(filename: string, rows: any[]) {
  if (!rows.length) return;
  const separator = ",";
  const keys = Object.keys(rows[0]);
  const csvContent =
    keys.join(separator) +
    "\n" +
    rows
      .map((row) =>
        keys
          .map((k) => {
            let cell = row[k] === null || row[k] === undefined ? "" : row[k];
            cell = cell.toString().replace(/"/g, '""');
            if (cell.search(/("|,|\n)/g) >= 0) cell = `"${cell}"`;
            return cell;
          })
          .join(separator)
      )
      .join("\n");

  const blob = new Blob([csvContent], { type: "text/csv;charset=utf-8;" });
  const link = document.createElement("a");
  link.href = URL.createObjectURL(blob);
  link.setAttribute("download", filename);
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
}

const Compliance = () => {
  const [complianceScreen, setComplianceScreen] = useState(1);
  const [searchTerm, setSearchTerm] = useState<string>("");
  const navigate = useNavigate();
  const [transactions, setTransactions] = useState<{
    summary: {
      flaggedTransactions: number;
      totalValueHeld: number;
      overallRiskScore: number;
      highRiskUsers: number;
    };
  }>({
    summary: {
      flaggedTransactions: 0,
      totalValueHeld: 0,
      overallRiskScore: 0,
      highRiskUsers: 0,
    },
  });
  const [customerLoadder, setCustomerLoader] = useState<boolean>(false);
  const transactionMonitoringRef = useRef<any>(null);
  const amlTableRef = useRef<any>(null);
  const ipTableRef = useRef<any>(null);

  const fetchData = async () => {
    try {
      const { data } = await axiosInstance.get(
        `${API_URL}api/rules/transactions`
      );

      setTransactions(data.data);
    } catch (error: any) {
      console.log(error.response?.data?.message || "An error occurred");
    } finally {
      setCustomerLoader(false);
    }
  };
  useEffect(() => {
    fetchData();
  }, []);

  const handleExport = () => {
    if (complianceScreen === 1 && transactionMonitoringRef.current) {
      const data = transactionMonitoringRef.current.getData();
      if (data && data.length) exportToCsv("transaction-monitoring.csv", data);
    } else if (complianceScreen === 2 && amlTableRef.current) {
      const data = amlTableRef.current.getData();
      if (data && data.length) exportToCsv("aml-logs.csv", data);
    } else if (complianceScreen === 3 && ipTableRef.current) {
      const data = ipTableRef.current.getData();
      if (data && data.length) exportToCsv("ip-restrictions.csv", data);
    }
  };

  return (
    <div className="w-full h-screen flex flex-col overflow-hidden">
      <div className="w-full h-[31px] shrink-0 bg-[#1B1B1B] flex justify-center items-center">
        {IS_STAGING ? (
          <h4 className="font-medium text-[#AEBCC6] text-[12px]">
            You are in Staging:{" "}
            <span>
              <a href={PROD_LINK} className="text-[#03C668]">
                Switch to Prod
              </a>
            </span>
          </h4>
        ) : (
          <h4 className="font-medium text-[#AEBCC6] text-[12px]">
            You are in PROD:{" "}
            <span>
              <a href={STAGING_LINK} className="text-[#DF4E4E]">
                Switch to Staging
              </a>
            </span>
          </h4>
        )}
      </div>
      <div className="flex flex-1 min-h-0 w-full flex-col lgss:flex-row overflow-hidden">
        <Sidebar />
        <div className="w-full lgss:w-10/12 flex-1 min-h-0 min-w-0 overflow-y-auto bg-[#13181B]">
          <Navbar />
          <div className="w-full px-5 h-full pt-8 mds:px-12 font-manrope lgss:px-10  bg-[#13181B]">
            <div className="w-full font-manrope">
              {complianceScreen === 1 && (
                <div className="w-full grid grid-cols-1 gap-4 mt-4 mb-6 md:grid-cols-2 lgss:grid-cols-4">
                  <div className="border border-[#2C363E] rounded-xl h-[90px] p-4">
                    <h4 className="text-[11px] text-[#0A6AAF] font-bold">
                      Flagged Transaction
                    </h4>
                    <h4 className="text-[22px] text-[#BEE1FB] font-sora mt-2 font-bold">
                      {transactions?.summary?.flaggedTransactions}
                    </h4>
                  </div>
                  <div className="border border-[#2C363E] rounded-xl h-[90px] p-4">
                    <h4 className="text-[11px] text-[#F28A0F] font-bold">
                      Total Value of Held Transactions
                    </h4>
                    <h4 className="text-[22px] text-[#BEE1FB] font-sora mt-2 font-bold">
                      $ {transactions?.summary?.totalValueHeld}
                    </h4>
                  </div>
                  <div className="border border-[#2C363E] rounded-xl h-[90px] p-4">
                    <h4 className="text-[11px] text-[#0FBCF2] font-bold">
                      Overall Risk Score
                    </h4>
                    <h4 className="text-[22px] text-[#BEE1FB] font-sora mt-2 font-bold">
                      {transactions?.summary?.overallRiskScore}
                    </h4>
                  </div>
                  <div className="border border-[#2C363E] rounded-xl h-[90px] p-4">
                    <h4 className="text-[11px] text-[#9747FF] font-bold">
                      High Risk Users
                    </h4>
                    <h4 className="text-[22px] text-[#BEE1FB] font-sora mt-2 font-bold">
                      {transactions?.summary?.highRiskUsers}
                    </h4>
                  </div>
                </div>
              )}
              <div className="flex justify-between items-center h-[67px] bg-[#0D0D0D] ">
                <div className="flex justify-start  items-center">
                  <button
                    onClick={() => setComplianceScreen(1)}
                    className={`${
                      complianceScreen === 1
                        ? "text-secondary_button border-b-2 h-[67px] px-4 border-secondary_button font-bold text-[14px]"
                        : "text-gray-200  text-[14px] h-[67px] px-4"
                    }`}
                  >
                    Transaction Monitoring
                  </button>
                  <button
                    onClick={() => setComplianceScreen(2)}
                    className={`${
                      complianceScreen === 2
                        ? "text-secondary_button border-b-2 h-[67px] px-4 border-secondary_button font-bold text-[14px]"
                        : "text-gray-200  text-[14px] h-[67px] px-4"
                    }`}
                  >
                    AML logs
                  </button>
                  <button
                    onClick={() => setComplianceScreen(3)}
                    className={`${
                      complianceScreen === 3
                        ? "text-secondary_button border-b-2 h-[67px] px-4 border-secondary_button font-bold text-[14px]"
                        : "text-gray-200  text-[14px] h-[67px] px-4"
                    }`}
                  >
                    IP Restrictions
                  </button>
                </div>
                <div className="flex justify-end gap-2 mr-4 items-center">
                  {/* search input with search icon */}

                  <div className="flex justify-center items-center gap-2 px-2 bg-[#191919] h-[42px] rounded-xl  text-[14px]">
                    <FiSearch className="text-gray-200 text-[18px]" />
                    <input
                      type="search"
                      placeholder="Search"
                      value={searchTerm}
                      onChange={(e) => {
                        setSearchTerm(e.target.value);
                      }}
                      className="bg-transparent w-[80px] outline-none text-gray-200"
                    />
                  </div>
                  <button
                    className="text-gray-200 flex justify-center items-center gap-2 px-2 bg-[#191919] h-[42px] rounded-xl  text-[14px]"
                    onClick={handleExport}
                  >
                    <FiUpload className="text-gray-200 text-[16px]" />
                    Export
                  </button>
                  <button
                    onClick={() => navigate("/kyc-logs/rules")}
                    className="text-gray-200 flex justify-center items-center gap-1 px-2 bg-secondary_button h-[42px] rounded-xl  text-[14px]"
                  >
                    <RiUserSearchLine className="text-gray-50 text-[20px]" />
                    Risk Configuration
                  </button>
                </div>
              </div>
              {complianceScreen === 1 ? (
                <TransactionMonitoring
                  ref={transactionMonitoringRef}
                  searchTerm={searchTerm}
                />
              ) : complianceScreen === 2 ? (
                <AmlTable ref={amlTableRef} searchTerm={searchTerm} />
              ) : complianceScreen === 3 ? (
                <IpTable ref={ipTableRef} searchTerm={searchTerm} />
              ) : null}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Compliance;
